import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Link } from "react-router-dom";

export default function MyLearning() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/enrollments/mine").then(r => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <Layout>
      <div className="px-10 py-10 max-w-6xl">
        <div className="overline mb-3">Learner</div>
        <h1 className="editorial-h1 text-5xl mb-10">My Learning</h1>
        {items.length === 0 ? (
          <div className="editorial-card-static p-12 text-center">
            <div className="font-serif text-2xl mb-2">No enrollments yet.</div>
            <div className="text-[#52525B] mb-6">Browse the marketplace to find your first course.</div>
            <Link to="/marketplace" className="btn-primary" data-testid="learning-browse">Browse marketplace</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {items.map(e => (
              <Link key={e.enrollment_id} to={`/learn/${e.course_id}`} data-testid={`learning-card-${e.course_id}`} className="editorial-card p-0 flex">
                {e.course?.thumbnail && <img src={e.course.thumbnail} className="w-40 h-40 object-cover flex-shrink-0" alt="" />}
                <div className="p-5 flex-1">
                  <div className="overline mb-1">{e.course?.category || "Course"}</div>
                  <div className="font-serif text-xl leading-tight mb-3">{e.course?.title}</div>
                  <div className="h-1 bg-[#E4E4E7] mb-2"><div className="h-1 bg-[#E63946]" style={{ width: `${e.progress_pct}%` }} /></div>
                  <div className="flex items-center justify-between mt-2">
                    <span className="overline">{e.progress_pct}% complete</span>
                    <span className="overline">{e.status}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
